import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default class Example extends PureComponent {
  static demoUrl = "https://codesandbox.io/s/simple-bar-chart-tpz8r";

  render() {
    const { last_10SalesRevenue } = this.props;

    // Dynamically map the data instead of hardcoding indices 0-9
    const data = (last_10SalesRevenue || []).map((item) => {
      const dateParts = (item.day_date || "").split('-');
      const formattedName = dateParts.length >= 3 ? `${dateParts[1]}-${dateParts[2]}` : (item.day_date || "N/A");

      return {
        name: formattedName,
        Price: item.Price || 0,
      };
    }).slice(0, 10); // Keep it to last 10 as intended

    const maxSales = data.length > 0 ? Math.max(...data.map((item) => item.Price)) : 0;
    const yDomain = [0, maxSales > 0 ? Math.ceil(maxSales / 1000) * 1000 : 1000];

    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis domain={yDomain} />
          <Tooltip />
          <Legend />
          <Bar dataKey="Price" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
